export const MinusIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <rect x="1" y="9.13428" width="22" height="5" rx="1" fill="#FE6F01" />
        </svg>
    )
}